import { render, staticRenderFns } from "./HeaderSearch.vue?vue&type=template&id=fc65de54&scoped=true"
import script from "./HeaderSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderSearch.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HeaderSearch.vue?vue&type=style&index=0&id=fc65de54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc65de54",
  null
  
)

export default component.exports